export const formatDateRange = (start, end) => {
  if (!start || !end) return "N/A";

  const options = { month: "long", day: "numeric" };
  const startDate = new Date(start);
  const endDate = new Date(end);

  return `${startDate.toLocaleDateString(
    "en-US",
    options
  )} - ${endDate.toLocaleDateString("en-US", options)}`;
};

export const formatStayTime = (
  arrivalDate,
  checkIn,
  departureDate,
  checkOut
) => {
  if (!arrivalDate || !checkIn || !departureDate || !checkOut) return "N/A";

  const arrival = new Date(arrivalDate);
  const departure = new Date(departureDate);

  const options = { weekday: "long" };
  const arrivalDay = arrival.toLocaleDateString("en-US", options);
  const departureDay = departure.toLocaleDateString("en-US", options);

  return `${arrivalDay}, ${checkIn} - ${departureDay}, ${checkOut}`;
};
